module.exports = __webpack_public_path__ + "assets/img/img-hotel-07.1adf6d60.jpg";